export const widgetTemplates = [
    {
        name: "Kick Starter",
        description: "a very simple widget configuration to be used as a starter",
        emoji: "𓇬",
        id: "",
        color: "#C47ADA",
        days: "90",
        keywords: ["Nomie6", "Wordcloud"]
    }
];
